export enum UserActionEnum {
  SET_USERINFO = "SET_USERINFO",
  RESET = "RESET",
}
